import api from '@/api/app'
const school = {
  school: {
    viewInfo: {
      obj: {
        btns: [
          {
            label: '',
            model: 'comment',
            type: 'img',
            status: 0
          },
          {
            label: '|',
            model: '',
            type: 'text',
            status: 0
          },
          {
            label: '收藏',
            model: 'evaluate',
            type: 'img',
            status: 0
          },
          {
            label: '分享',
            model: 'share',
            type: 'img',
            status: 0
          },
          {
            label: '转存',
            model: 'unload',
            type: 'img',
            status: 0
          },
          {
            label: '举报',
            model: 'inform',
            type: 'img',
            status: 0
          }
        ],
        btns1: [
          {
            label: '装备清单',
            path: '/equip/projectList',
            model: 'equip1',
            status: 0
            // path: "/equip/goodsList"
          },
          {
            label: '工程清单',
            path: '/equip/projectList',
            model: 'equip2',
            status: 0
          },
          {
            label: '装备标准',
            path: '/notes/standard',
            model: 'equip3',
            status: 0
          }
        ]
      },
      data: {
        data1: [
          {
            name: '猜你喜欢产品1',
            img: 'equip1',
            type: 1,
            collectNum: '101'
          },
          {
            name: '猜你喜欢产品2',
            img: 'equip1',
            type: 1,
            collectNum: '101'
          },
          {
            name: '猜你喜欢产品3',
            img: 'equip1',
            type: 2,
            collectNum: '101'
          },
          {
            name: '猜你喜欢产品1',
            img: 'equip1',
            type: 2,
            collectNum: '101'
          },
          {
            name: '猜你喜欢产品2',
            img: 'equip1',
            type: 3,
            collectNum: '101'
          },
          {
            name: '猜你喜欢产品3',
            img: 'equip1',
            type: 3,
            collectNum: '101'
          },
          {
            name: '猜你喜欢产品1',
            img: 'equip1',
            type: 4,
            collectNum: '101'
          },
          {
            name: '猜你喜欢产品2',
            img: 'equip1',
            type: 4,
            collectNum: '101'
          }
        ],
        data2: {
          imgs: [1, 2],
          total: 101
        }
      }
    },
    control: {
      /**
             * 当前操作 是否是编辑用户
             * @date 2021-04-23
             * @param {any} condition //条件数组
             * @returns {any}
             */
      isEdit: (condition) => {
        return condition[0] == 2
      }
    },
    init: {
      initConfigs: [
        {
          label: 'searchData1',
          model: null
        },
        {
          label: 'searchData2',
          model: null
        },
        {
          label: 'searchData3',
          model: null
        },
        {
          label: 'searchData4',
          model: 'params'
        },
        {
          label: 'notesData5',
          model: 'params'
        },
        {
          label: 'notesData6',
          model: 'params'
        },
        {
          label: 'notesData7',
          model: 'params'
        }
      ],
      types: () => {
        return new Promise((resolve) => {
          api.school.retrieve.conditions().then((res) => {
            if (res.data.length) {
              res.data.map((item, index) => {
                item.default = `${index}-0`
                item.children.unshift({
                  id: 0,
                  name: `全部${item.title}`
                })
              })
            }
            resolve(res.data)
          })
        })
      },
      data: (obj) => {
        return new Promise((resolve) => {
          api.school.retrieve.data(obj).then((res) => {
            if (res.data.data.length) {
              res.data.data.map((item) => {
                item.name = item.school_name
                item.cover_pic = item.cover_img
              })
            }
            resolve(res.data)
          })
        })
      },
      dto: (obj) => {
        return new Promise((resolve) => {
          api.school.retrieve.dto(obj).then((res) => {
            if (res.data.length) {
              res.data[0].share = null
              res.data[0].show = res.data[0].look_num
              res.data[0].imgList = []
              res.data[0].img_urls.map((item, index) => {
                res.data[0].imgList.push({
                  id: index,
                  img: item
                })
              })
              if (res.data[0].school_room.length) {
                res.data[0].school_room.map((item1, index1) => {
                  item1.content = item1.info
                })
              }
            }
            resolve(res.data[0])
          })
        })
      }
    },
    schoolDto: {
      viewInfo: {
        title: {
          obj: {
            btnList: [
              {
                label: '',
                model: 'show',
                type: 'img'
              },
              {
                label: '|',
                model: '',
                type: 'text'
              },
              {
                label: '',
                model: 'share',
                type: 'img'
              }
            ]
          },
          data: {
          }
        },
        content: {
          obj: {

          },
          data: {
            contentData1: {
              title: '教学空间展示',
              content: '校坚持改革开放，科学管理，依法治教，优质服务，高质量完成了各项目标责任。2019年在全市教体系统目标考核中荣获“教育体育工作先进单位”，“市平安建设工作先进单位”“信息化建设先进单位”等多项荣誉。学校办学理念先进，教学质量上乘，以培养“合格+特长”的学生、造就“科研+特长”的教师，创办“规范+特色”的学校为目标，“和谐、进取、自主、幸福”的校训，确立“文明和谐、开拓进取、求真向善、快乐自信”的校风，“敬业爱生、博学严谨、教学相长、求实创新”的教风，“励志笃行、勤勉乐学、自主合作、彰显个性”的学风，严抓常规教学，坚持因材施教，实行分层教学，提倡自主学习、合作探究、反馈提升的教育教学方式。学校被评为“全国实验学鹤壁市实验学校艺术长廊即是校园文化凝聚力与创造力的体现，营造出与众不同的符合学校文化气息的氛围，具有渗透性、持久性和选择性，对于提高学生的人文道德素养，拓宽同学们的视野，培养跨世纪人才具有深远意义。通过对学生不同学科优秀作品的展示，极大地提高学生们对不同文化领域的认识与兴趣，让学生们置身其中感受，在潜移默化中被感染学习，健康、向上、丰富的的校园文化展示对学生的人生观、价值观产生着潜移默化的深远影响，而这种影响往往是任何课程所无法比拟的。鹤壁市实验学校艺术长廊即是校园文化凝聚力与创造力的体现，营造出与众不同的符合学校文化气息的氛围，具有渗透性、持久性和选择性，对于提高学生的人文道德素养，拓宽同学们的视野，培养跨世纪人才具有深远意义。通过对学生不同学科优秀作品的展示，极大地提高学生们对不同文化领域的认识与兴趣，让学生们置身其中感受，在潜移默化中被感染学习，健康、向上、丰富的的校园文化展示对学生的人生观、价值观产生着潜移默化的深远影响，而这种影响往往是任何课程所无法比拟的。鹤壁市实验学校艺术长廊即是校园文化凝聚力与创造力的体现，营造出与众不同的符合学校文化气息的氛围，具有渗透性、持久性和选择性，对于提高学生的人文道德素养，拓宽同学们的视野，培养跨世纪人才具有深远意义。通过对学生不同学科优秀作品的展示，极大地提高学生们对不同文化领域的认识与兴趣，让学生们置身其中感受，在潜移默化中被感染学习，健康、向上、丰富的的校园文化展示对学生的人生观、价值观产生着潜移默化的深远影响，而这种影响往往是任何课程所无法比拟的。'
            },
            contentData2: {
              imgs: [1, 2],
              total: 101
            },

            tabsList: [
              {
                name: '最新资讯1',
                path: '/information'
              },
              {
                name: '最新资讯2',
                path: '/information'
              }
            ],
            tabsData1: [
              {
                content: '1-1首先是物理、化学、生物实验室，一走进理化生实验室',
                time: '2021-08-10'
              },
              {
                content: '1-2首先是物理、化学、生物实验室，一走进理化生实验室',
                time: '2021-08-11'
              },
              {
                content: '1-3首先是物理、化学、生物实验室，一走进理化生实验室',
                time: '2021-08-12'
              }
            ],
            tabsData2: [
              {
                content: '2-1首先是物理、化学、生物实验室，一走进理化生实验室',
                time: '2022-08-10'
              },
              {
                content: '2-2首先是物理、化学、生物实验室，一走进理化生实验室',
                time: '2022-08-11'
              },
              {
                content: '2-3首先是物理、化学、生物实验室，一走进理化生实验室',
                time: '2022-08-12'
              }
            ]
          }
        }
      },
      control: {
        /**
                 * 当前操作 是否是编辑用户
                 * @date 2021-04-23
                 * @param {any} condition //条件数组
                 * @returns {any}
                 */
        isEdit: (condition) => {
          return condition[0] == 2
        }
      }
    }
  }
}
export default school
